class UltraQuestions extends HTMLElement {
    constructor() {
        super();

        this.data = this.fetchData();
        this.questionTemplate = this.querySelector('.js-question-template').innerHTML;
        this.answerTemplate = this.querySelector('.js-answer-template').innerHTML;
        this.scrollWrapper = this.querySelector('.js-scroll-wrapper');
        this.scroll = this.querySelector('.js-scroll');
        this.activeQuestion = this.data.groups[0].questions[0];
        this.activeGroup = this.data.groups[0];

        this.scroll.addEventListener('scroll', this.updateShadows.bind(this));
        this.addEventListener('click', this.handleClick.bind(this));

        this.updateShadows();
        window.addEventListener("resize", this.updateShadows.bind(this));
    }

    handleClick(event) {
        const target = event.target;

        if (target.classList.contains('js-question')) {
            event.preventDefault();
            this.toggleQuestion(target);
        } else if (target.classList.contains('js-close')) {
            event.preventDefault();
            this.closeQuestion(target);
        } else if (target.classList.contains('js-toggle')) {
            event.preventDefault();
            this.toggleFilter(target);
        }
    }

    updateShadows() {
        const isScrollable = this.scroll.scrollWidth > this.scroll.clientWidth;
        if (!isScrollable) {
            this.scrollWrapper.classList.add(
                "ultra-questions__filter-wrapper--no-left-shadow",
                "ultra-questions__filter-wrapper--no-right-shadow"
            );
            return;
        }
        const atStart = this.scroll.scrollLeft === 0;
        const atEnd =
            this.scroll.scrollLeft + this.scroll.clientWidth >=
            this.scroll.scrollWidth - 1;

        this.scrollWrapper.classList.toggle(
            "ultra-questions__filter-wrapper--no-left-shadow",
            atStart
        );
        this.scrollWrapper.classList.toggle(
            "ultra-questions__filter-wrapper--no-right-shadow",
            atEnd
        );
    }

    toggleFilter(target) {
        const container = this.querySelector('.ultra-questions__questions-wrapper');
        container.classList.add('ultra-questions__questions-wrapper--loading');
        setTimeout(() => {
            const questionsContainer = this.querySelector('.js-questions');
            const attr = target.dataset.attr;
            const group = this.data.groups.find((group) => group.handle === attr);
            this.activeGroup = group;
            this.activeQuestion = group.questions[0];

            const toggles = this.querySelectorAll('.js-toggle');
            toggles.forEach((toggle) => {
                toggle.classList.toggle('ultra-questions-toggle--active', toggle === target)
            })

            questionsContainer.innerHTML = "";
            group.questions.forEach((question, index) => {
                const template = new DOMParser().parseFromString(this.generateQuestion(question), 'text/html').body.children[0];
                if (index === 0) template.classList.add('ultra-questions-question--active');
                questionsContainer.append(template);
            });

            this.updateAnswer(group.questions[0]);
            container.classList.remove('ultra-questions__questions-wrapper--loading');
        }, 200);
    }

    generateQuestion(question) {
        const rendered = Mustache.render(this.questionTemplate, question);
        return rendered;
    }

    closeQuestion() {
        const answerContainer = this.querySelector('.js-answer');
        answerContainer.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
    }

    toggleQuestion(target) {
        this.activeQuestion = this.activeGroup.questions.find((question) => question.handle === target.dataset.attr);

        const questions = this.querySelectorAll('.js-question')
        questions.forEach((question) => {
            const container = question.closest('.ultra-questions-question');
            container.classList.toggle('ultra-questions-question--active', question === target)
        });

        const isDesktop = window.matchMedia("(min-width: 768px)").matches;
        const answerWrapper = this.querySelector('.ultra-questions__answers');
        const answerContainer = this.querySelector('.js-answer');

        if (isDesktop) {
            answerWrapper.classList.add('ultra-questions__answers--loading')
            setTimeout(() => {
                this.updateAnswer(this.activeQuestion);
                answerWrapper.classList.remove('ultra-questions__answers--loading')
            }, 400);
            return;
        }

        this.updateAnswer(this.activeQuestion);
        answerContainer.classList.toggle('active');
        document.body.classList.toggle('overflow-hidden');
    }

    updateAnswer(question) {
        const answerContainer = this.querySelector('.js-answer');
        answerContainer.innerHTML = "";
        answerContainer.innerHTML += this.generateAnswer(question);
    }

    generateAnswer(question) {
        const rendered = Mustache.render(this.answerTemplate, question);
        return rendered;
    }

    // Required to escape the quotes for the JSON parse
    fetchData() {
        let jsonText = this.querySelector('.js-data').innerHTML;
        jsonText = jsonText.replace(/`([\s\S]*?)`/g, function (match, p1) {
            return '"' + p1.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"';
        });
        return JSON.parse(jsonText)
    }
}

customElements.define('ultra-questions', UltraQuestions)